import { Box, styled } from '@mui/material';
import React from 'react';

import { COLORS } from '../../../../../../configs/colors';
import { SlideProps } from '../SwipeableServiceCard.props';

const TagsContainer = styled(Box)({
  display: 'flex',
  gap: '4px',
  flexWrap: 'wrap',
  marginBottom: '10px',
});

const Tag = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'tagColor',
})<{ tagColor?: string }>(({ tagColor }) => ({
  fontSize: '0.65rem',
  padding: '3px 8px',
  borderRadius: '50px',
  background: tagColor ? `${tagColor}14` : 'rgba(23, 104, 120, 0.08)',
  color: tagColor || COLORS.NavyBlue,
  fontWeight: 500,
}));

const InfoLabel = styled(Box)({
  fontWeight: 600,
  fontSize: '0.65rem',
  textTransform: 'uppercase',
  letterSpacing: '0.8px',
  color: COLORS.LightGrey,
  marginBottom: '3px',
});

const InfoValue = styled(Box)({
  fontSize: '0.82rem',
  color: COLORS.Black,
  marginBottom: '8px',
});

interface ParsedTag {
  id?: number;
  title: string;
  color?: string;
}

const parseTags = (tags: unknown): ParsedTag[] => {
  if (!tags) return [];

  try {
    const raw = typeof tags === 'string' ? JSON.parse(tags) : tags;
    if (!Array.isArray(raw)) return [];

    return raw
      .filter((t): t is Record<string, unknown> => t && typeof t === 'object' && 'title' in t)
      .map((t) => ({
        id: typeof t.id === 'number' ? t.id : undefined,
        title: String(t.title),
        color: typeof t.color === 'string' ? t.color : undefined,
      }));
  } catch {
    // Fallback: treat as comma-separated plain strings
    if (typeof tags === 'string') {
      return tags.split(',').map((t) => ({ title: t.trim() }));
    }
    return [];
  }
};

export const DetailsSlide: React.FC<SlideProps> = ({ service }) => {
  const tags = parseTags(service.tags);

  return (
    <Box data-slide="3">
      <InfoLabel>Fault Code</InfoLabel>
      <InfoValue>{service.reportedFaultDescription || '-'}</InfoValue>

      <InfoLabel>Fault Description</InfoLabel>
      <InfoValue>{service.reportedFaultDescriptionCombine || '-'}</InfoValue>

      {tags.length > 0 && (
        <TagsContainer>
          {tags.map((tag, index) => (
            <Tag key={tag.id ?? index} tagColor={tag.color}>{tag.title}</Tag>
          ))}
        </TagsContainer>
      )}
    </Box>
  );
};
